export class UI_STRINGS {
    static SEARCH_PRIMARY_PROVIDER = "Search Provider"
    static SEARCH_CLINICAL_LIAISON="Search Clinical Liaison"
}

export class ELIGIBILITY_STATES_ID {
    static ENROLLED = "9076c944-0253-47c2-9dd6-a39caaeb296e";
}
